export const isMobileDevice = () =>
	typeof navigator !== 'undefined' && /Mobi|Android/i.test(navigator.userAgent);
